import { Route, Routes } from "react-router-dom";
import GreenhouseCreate from "../pages/greenhouse/GreenhouseCreate";
import GreenhousesShow from "../pages/greenhouse/GreenhousesShow";
import GreenhouseShow from "../pages/greenhouse/GreenhouseShow";
import GreenhouseEdit from "../pages/greenhouse/GreenhouseEdit";
import GreenmoduleCreate from "../pages/greenhouse/GreenmoduleCreate";
import GreenmoduleShow from "../pages/greenhouse/GreenmoduleShow";
import TermometerCreate from "../pages/greenhouse/TermometerCreate";
import Termometerdashboard from "../pages/greenhouse/Termometerdashboard";
import GreenmoduleEdit from "../pages/greenhouse/GreenmoduleEdit";


export default function GreenhouseDisplay() {
    // CreatePlanes
    return (
        <Routes>
            <Route path='creategreenhouse' element={<GreenhouseCreate />} />
            <Route path='showgreenhouses' element={<GreenhousesShow />} />
            <Route path='showgreenhouse/:id' element={<GreenhouseShow />} />
            <Route path='editgreenhouse/:id' element={<GreenhouseEdit />} />

            <Route path='creategreenmodule/:greenhouesid' element={<GreenmoduleCreate />} />
            <Route path='showgreenmodule/:id' element={<GreenmoduleShow />} />
            <Route path='editgreenmodule/:id' element={<GreenmoduleEdit />} />

            <Route path='createtermometer/:greenmodulesid' element={<TermometerCreate />} />
            <Route path='showtermometer/:termometerid' element={<Termometerdashboard />} />

        </Routes>
    );
}